import React from 'react';
import { Field } from 'react-final-form';
import ErrorMessage from '../components/error-message';
import { yesNoNoValidator } from '../util/validator';
export const YesNoNoErrorCheckField = _ref => {
  let {
    mainQuestionName,
    firstSubQuestionName,
    secondSubQuestionName,
    identifier
  } = _ref;
  return /*#__PURE__*/React.createElement(Field, {
    name: "yes-no-no-selection_".concat(identifier),
    validate: (value, allValues) => {
      return yesNoNoValidator(allValues === null || allValues === void 0 ? void 0 : allValues[mainQuestionName], allValues === null || allValues === void 0 ? void 0 : allValues[firstSubQuestionName], allValues === null || allValues === void 0 ? void 0 : allValues[secondSubQuestionName]);
    },
    render: _ref2 => {
      let {
        meta
      } = _ref2;
      return meta.error ? /*#__PURE__*/React.createElement("div", {
        className: "medium-margin-top"
      }, /*#__PURE__*/React.createElement(ErrorMessage, {
        text: meta.error
      })) : '';
    }
  });
};